import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const modalFooter = css`
  justify-content: flex-end;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    justify-content: flex-start;
    gap: 0.75rem;
    margin: 0;
  }
`;

export const button = css`
  margin-left: 1rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin: 0;
  }
`;

export const blurBackground = css`
  backdrop-filter: blur(0.3rem);
`;
